import { isKernelEventType } from "@econ-v1/domain";
import { requiredString } from "./transaction.js";
export class SqliteDurableRepositoryEventStore {
    #database;
    constructor(database) {
        this.#database = database;
    }
    async listUndelivered() {
        return this.#database.selectObjects(`SELECT sequence, event_type, occurred_at, payload_json, delivery_attempts, delivered_at
        FROM repository_events WHERE delivered_at IS NULL ORDER BY sequence`).map(repositoryEvent);
    }
    async markDeliveryAttempt(sequence) {
        this.#database.exec(`UPDATE repository_events SET delivery_attempts = delivery_attempts + 1
        WHERE sequence = ? AND delivered_at IS NULL`, { bind: [sequence] });
    }
    async markDelivered(sequence, deliveredAt) {
        this.#database.exec("UPDATE repository_events SET delivered_at = ? WHERE sequence = ? AND delivered_at IS NULL", { bind: [deliveredAt, sequence] });
    }
}
function repositoryEvent(row) {
    const type = requiredString(row.event_type, "repository event type");
    if (!isKernelEventType(type))
        throw new TypeError("Stored repository event type is invalid");
    const payload = JSON.parse(requiredString(row.payload_json, "repository event payload_json"));
    return {
        deliveredAt: row.delivered_at === null ? undefined : requiredString(row.delivered_at, "delivered_at"),
        deliveryAttempts: requiredInteger(row.delivery_attempts, "delivery_attempts"),
        event: {
            occurredAt: requiredString(row.occurred_at, "repository event occurred_at"),
            payload,
            type,
        },
        sequence: requiredInteger(row.sequence, "repository event sequence"),
    };
}
function requiredInteger(value, field) {
    if (typeof value !== "number" || !Number.isSafeInteger(value)) {
        throw new TypeError(`Expected ${field} to be an integer`);
    }
    return value;
}
//# sourceMappingURL=durable-event-store.js.map